import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children:[
      {
        path: '',
        loadComponent: () => import('./why-kudoshub.component').then(m => m.WhyKudoshubComponent),
        data: {
          title: 'KudosHub | Why Kudoshub',
          description:'KudosHub is committed to providing an innovative environment to its clients with its easy-to-use platforms for every stage of your company’s growth.',
          keywords: 'best email marketing, email list cleaning, web development, mobile apps',
          ogTitle: 'KudosHub | Why Kudoshub',
          ogDesc: 'KudosHub is committed to providing an innovative environment to its clients with its easy-to-use platforms for every stage of your company’s growth.',
          ogImage: 'https://kudoshub.com/theme/images/img02.gif',
          ogUrl: 'https://kudoshub.com/why-kudoshub',
          twitterTitle: 'KudosHub | Why Kudoshub',
          twitterDesc: 'KudosHub is committed to providing an innovative environment to its clients with its easy-to-use platforms for every stage of your company’s growth.',
          twitterImage: 'https://kudoshub.com/theme/images/img02.gif'
          }
      }
    ]
  }
];
